export default "__VITE_ASSET__p224k8ds__"